/* eslint-disable react/prop-types */
import MainInfosComponent from "./main-infos";
import { useState } from "react";

function MainInfos({ announcement, updateAnnouncement }) {
  const [isTitleValid, setTitleValid] = useState(announcement.title);

  const handleTitleChange = (e) => {
    updateAnnouncement("title", e.target.value, announcement);
    if (e.target.value) {
      setTitleValid(true);
    } else {
      setTitleValid(false);
    }
  };

  return (
    <MainInfosComponent
      onTitleChange={handleTitleChange}
      isTitleValid={isTitleValid}
      announcement={announcement}
    />
  );
}

export default MainInfos;
